window.TV2 = window.TV2 || {};

TV2.editButton = (id, source, container, editUrl) => {
  const labradorUrl = editUrl || 'https://labrador.tv2.no';
  const target = document.querySelector(container || '.articleheader__text');
  const labbutton = document.createElement('a');
  const src = source || '';

  if (TV2.getCookieValue('LABACTIVE')) {
    if (target) {
      labbutton.classList.add('editArticleLogo');

      if (src === 'escenic') {
        labbutton.classList.add('editArticleLogo--disabled');
        labbutton.setAttribute('title', 'Gammel artikkel som ikke er importert i Labrador');
      } else {
        labbutton.setAttribute('target', '_blank');
        labbutton.setAttribute('href', `${labradorUrl}/edit/article/id/${id}`);
        labbutton.setAttribute('title', 'Edit in Labrador');
      }
      target.parentNode.insertBefore(labbutton, target.nextSibling);
      // target.insertAfter(labbutton);
    }
  }
};
